import {useRef} from 'react';
import {useSelector} from "react-redux";

const MapMarker = ({
                       plateNumber,
                       status,
                       cruiseStatus,
                       chassisNumber,
                       deviceId,
                       onClick,
                       onContextMenu,
                       operationNumber
                   }) => {
    const getBackgroundColor = (cruiseStatus) => {
        switch (cruiseStatus) {
            case 'Rölanti':
                return 'rgb(232,225,58)';
            case 'Seyir Halinde':
                return 'rgb(38,67,207)';
            case 'Durma':
                return 'rgba(255, 0, 0, 1)';
            case 'Park':
                return 'rgba(128, 128, 128, 1)';
            case 'Takip':
                return 'rgba(255,161,0,0.96)';
            default:
                return 'rgb(32,31,31)';
        }
    };

    const getBorderColor = (status) => {
        switch (status) {
            case 'red':
                return 'rgba(255, 0, 0, 1)';
            case 'yellow':
                return 'rgba(255,255,1,1)';
            case 'green':
                return 'rgba(29,156,29,0.97)';
            case 'orange':
                return 'rgba(255,161,0,2)';
            case 'gray':
                return 'rgba(128, 128, 128, 0.9)';
            case 'black':
                return 'rgba(0, 0, 0, 0.9)';
            default:
                return '';
        }
    };

    const handleCircleRightClick = (event) => {
        event.preventDefault();
        if (onContextMenu) onContextMenu(event);
    };

    const renderContent = () => {
        switch (selectedDisplayOption) {
            case 'plateNumber':
                return plateNumber;
            case 'chassisNumber':
                return chassisNumber;
            case 'deviceId':
                return deviceId;
            case 'operationNumber':
                return operationNumber;
            default:
                return 'Bilinmiyor';
        }
    };


    const {selectedDisplayOption} = useSelector((state) => state.mapSettings);
    const markerRef = useRef(null);

    return (
        <div
            ref={markerRef}
            style={{
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <div className="marker-container">
                <div
                    className="marker-circle outer"
                    style={{
                        backgroundColor: getBackgroundColor(cruiseStatus),
                        width: '16px',
                        height: '16px',
                        borderRadius: '50%',
                        position: 'relative',
                    }}
                    onContextMenu={handleCircleRightClick}
                >
                    <div
                        style={{
                            position: 'absolute',
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            backgroundColor: getBorderColor(status),
                            top: -6,
                            left: -6,
                            zIndex: -1,
                        }}
                    />
                </div>
                <h4 className="plate-text">{renderContent()}</h4>
            </div>
        </div>
    );
};

export default MapMarker;
